
import { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
export function SignatureField({
	width = 500,
	height = 200,
	value,
	onChange,
	required, 
	className = ""
}:{
	width?: number,
	height?: number,
	value: string,
	onChange: (next:string) => void,	
	required: boolean,
	className?: string
}) {
	const ref = useRef<SignatureCanvas>(null);
	const handleEnd = () => {
		const dataUrl = ref.current?.toDataURL("image/png");
		onChange(dataUrl ?? "");
	};
	return (
		<div className = {className}>
			<SignatureCanvas
				ref = {ref}
				canvasProps = {{
					width,
					height,
					className: "border rounded"
				}}
				onEnd={handleEnd}
			/>
			<div>
				<button
					children = "Clear"
					type = "button"
					className = "btn btn-sm btn-secondary mt-2"
					onClick = {() => {
						ref.current?.clear();
						onChange("");
					}}
				/>
			</div>
			{required && !value && (
			<div className = "text-danger mt-1">
				Signature is required
			</div>
			)}

		</div>
	);
}